export enum PeriodEnum {
  YESTERDAY = 'yesterday',
  LAST_7_DAYS = 'last7',
  LAST_WEEK = 'lastWeek',
  LAST_30_DAYS = 'last30',
  CURRENT_MONTH = 'currentMonth',
  LAST_MONTH = 'lastMonth',
  CURRENT_YEAR = 'currentYear',
  LAST_YEAR = 'lastYear',
  ALL = 'all',
  SELECT = 'select'
}
